// extracted by mini-css-extract-plugin
export default {"tabs":"inbox_tabs__kDLal","badge":"inbox_badge__M7q90","wrapperTabs":"inbox_wrapperTabs__exlIb","title":"inbox_title__hZCjf"};